import type { PageContext } from 'vike/types'

import { legalDocKeyForPath } from '../../data/legalDocs'

export function route(pageContext: PageContext) {
  const doc = legalDocKeyForPath(pageContext.urlPathname)
  if (!doc) {
    return false
  }
  return { routeParams: { doc } }
}
